import React, { FormEvent, } from 'react';
import { Checkbox, FormControl, FormControlLabel, FormHelperText, Grid, InputLabel, OutlinedInput, Typography } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { User, UserError } from 'types/user';
import { isValidEmail, EMAIL_VALIDATION_ERROR_MESSAGE } from 'utils/validate-email';
interface ContactInformationProps {
    settings?: boolean;
    user: User;
    handleChange: (key: string, value: string | boolean) => void;
    handleInvalid: (event: FormEvent<HTMLElement>) => void;
    error: UserError;
    handleEmailValidationError?: (isInvalid: boolean) => void;
}
export const ContactInformation: React.FC<ContactInformationProps> = ({
    settings, user, handleChange, handleInvalid, error, handleEmailValidationError
}) => {
    const [errorEmail, setErrorEmail] = React.useState(false);
    
    const validateEmail = (email: string) => {
        if (!email) {
            setErrorEmail(false);
            if (handleEmailValidationError) {
                handleEmailValidationError(false);
            }
            return;
        }
        const isValid = isValidEmail(email);
        setErrorEmail(!isValid);
        if (handleEmailValidationError) {
            handleEmailValidationError(!isValid);
        }
    };

    const handleEmailChange = (value: string) => {
        handleChange("alternativeEmail", value);
        validateEmail(value);
    };

    const getEmailError = () => {
        if (errorEmail) {
            return EMAIL_VALIDATION_ERROR_MESSAGE;
        }
        return "";
    };
    return (
        <Accordion defaultExpanded={!settings}>
            <AccordionSummary tabIndex={-1}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="contact-information"
                id="contact-information"
            >
                <Typography sx={{ color: `neutral.main` }} variant="subtitle1">Contact information </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={5}>

                        <FormControl error={error.phoneNumber} fullWidth>
                            <InputLabel shrink={false}>Phone*</InputLabel>
                            <OutlinedInput name="phoneNumber"
                                value={user.phoneNumber}
                                onInvalid={(event) => handleInvalid(event)}
                                onChange={(event) => handleChange("phoneNumber", event.target.value)} type="text" required />
                            {error.phoneNumber && <FormHelperText color={'red'}>Phone is required</FormHelperText>}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={5}>

                        <FormControl fullWidth>
                            <InputLabel shrink={false}>Alternate phone </InputLabel>
                            <OutlinedInput name="alternativePhoneNumber"
                                value={user.alternativePhoneNumber}
                                onChange={(event) => handleChange("alternativePhoneNumber", event.target.value)} type="text" /></FormControl>
                    </Grid>
                    <Grid item xs={12} sm={5}>
                        <FormControl>
                            <FormControlLabel
                                control={<Checkbox color='secondary' id="phoneNumberIsMobile" name="phoneNumberIsMobile"
                                    value={user.phoneNumberIsMobile}
                                    onChange={(event) => handleChange("phoneNumberIsMobile", event.target.checked)} checked={user.phoneNumberIsMobile} />}
                                label="This is a mobile number"
                            />

                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={5}>
                        <FormControl>
                            <FormControlLabel
                                control={<Checkbox color='secondary' id="alternativePhoneNumberIsMobile" name="alternativePhoneNumberIsMobile"
                                    value={user.alternativePhoneNumberIsMobile}
                                    onChange={(event) => handleChange("alternativePhoneNumberIsMobile", event.target.checked)} checked={user.alternativePhoneNumberIsMobile} />}
                                label="This is a mobile number"
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={10}>
                        <FormControl error={errorEmail || error.emailDuplicated} fullWidth>
                            <InputLabel shrink={false}>Alternate email </InputLabel>
                            <OutlinedInput name="alternativeEmail"
                                value={user.alternativeEmail}
                                onChange={(event) => handleEmailChange(event.target.value)} 
                                onBlur={(event) => validateEmail(event.target.value)}
                                type="text" />
                            {errorEmail && <FormHelperText color={'red'}>{getEmailError()}</FormHelperText>}
                            {error.emailDuplicated && <FormHelperText color={'red'}> Alternate email must be different from your primary email</FormHelperText>}

                        </FormControl>
                    </Grid>


                </Grid>
            </AccordionDetails>
        </Accordion>



    )
}
